import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SignInPinCreate = ({ props }) => {
  const { login, password, info } = props;

  const [extra, setExtra] = useState({});
  
  const [pin, setPin] = useState("");
  const [newLastPin, setNewLastPin] = useState("");
  const [error, setError] = useState("");
  const [attemptsLeft, setAttemptsLeft] = useState(5);
  const navigate = useNavigate()

  const handlePress = (digit) => {
    if (pin.length >= 4) return;

    const newPin = pin + digit;
    setPin(newPin);
    setError("");

    if (newPin.length === 4) {
      setTimeout(() => {
        // 1-bosqich: PIN yaratilmoqda
        if (newLastPin.length !== 4) {
          setNewLastPin(newPin);
          setPin(""); // PIN'ni takrorlash uchun tozalash
        } else {
          // 2-bosqich: PIN tasdiqlanmoqda
          if (newPin === newLastPin) {
            // ✅ PIN tasdiqlandi
            const storeData = {
              n: extra.n,
              d: extra.d,
              i: newPin,
            };
            const encodedData = btoa(JSON.stringify(storeData));
            localStorage.setItem("store_info", encodedData);
            navigate(0)
            // bu yerga navigatsiya yoki JWT login chaqirishingiz mumkin
          } else {
            // ❌ PINlar mos emas
            setError("❌ PIN kodlar mos emas. Qayta urinib ko‘ring.");
            setNewLastPin("");
          }
          setPin("");
        }
      }, 500);
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
    setError("");
  };

  useEffect(() => {
    if (info) {
      try {
        const decodedData = JSON.parse(atob(info));
        setExtra(decodedData);
      } catch (err) {
        console.error("Decode error:", err);
      }
    }
  }, [info]);

  const renderDots = () => {
    return (
      <div className="flex justify-center gap-24 my-12">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`w-96 h-48 rounded-full border-2 flex items-center justify-center ${
              pin[i] ? "!border-blue" : "border-gray-400"
            }`}
          >
            <div
              className={`w-16 h-16 rounded-full ${
                pin[i] ? "bg-blue" : ""
              }`}
            />
          </div>
        ))}
      </div>
    );
  };

  const digits = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

  return (
    <div className="min-h-screen flex flex-col justify-between items-center p-32 bg-white">
      <div className="w-full text-center mt-10">
        <h2 className="text-2xl font-semibold mb-2">
          {newLastPin.length === 4 ? "PIN kodni takrorlang" : "PIN kodni yarating"}
        </h2>

        {renderDots()}

        {error && (
          <div className="text-red-600 text-sm mt-4">
            {error}
            <br />
            {attemptsLeft} urinish qoldi
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 gap-32 w-full max-w-sm mx-auto">
        {digits.slice(0, 9).map((digit) => (
          <button
            key={digit}
            onClick={() => handlePress(digit)}
            className="aspect-square rounded-full bg-gray-100 text-[32px] font-[700] shadow text-black active:bg-blue active:text-white"
          >
            {digit}
          </button>
        ))}

        <div></div>
        <button
          onClick={() => handlePress("0")}
          className="aspect-square rounded-full bg-gray-100 text-[32px] font-[700] shadow text-black"
        >
          0
        </button>
        <button
          onClick={handleDelete}
          className="aspect-square rounded-full text-[32px] font-[700] text-black"
        >
          ⌫
        </button>
      </div>

      <div className="h-10"></div>
    </div>
  );
};

export default SignInPinCreate;
